import {useState} from 'react'
import {FormItemProps, Input, InputProps, Space} from 'antd'

import {ProfileValues} from 'modules/users'
import {Box, Button, Form, FormItem, UserPhoto} from 'common/components'
import {FIELD_RULES} from 'common/constants'
import {FileInterface} from 'common/types'
import {useGetProfile, useUpdateProfile} from '..'

interface ProfileFormProps {
  onClose: () => void
}

const Field = ({
  name,
  type,
  readOnly,
  ...props
}: FormItemProps & InputProps) => (
  <FormItem {...props} name={name} rules={FIELD_RULES}>
    <Input
      type={type}
      addonBefore={name === 'phone' ? '+64' : undefined}
      readOnly={readOnly}
    />
  </FormItem>
)

export default function ProfileForm({onClose}: ProfileFormProps) {
  const {data: profile} = useGetProfile()
  const {mutate: updateProfile, isMutating} = useUpdateProfile(onClose)
  const [image, setImage] = useState<FileInterface>(
    profile?.photo ? {url: profile.photo} : {}
  )

  const isBorrower = profile.role === 'user'

  const handleFinish = ({email, phone, ...values}: ProfileValues) => {
    const newProfile: any = {
      ...values,
      phone: `+64${phone.trim()}`,
    }
    if (image.uuid) {
      newProfile.photo = image.uuid
    }
    if (email !== profile.email) {
      newProfile.email = email
    }
    updateProfile(newProfile)
  }

  const initialValues = {
    firstName: profile.firstName,
    lastName: profile.lastName,
    email: profile.email,
    phone: profile.phone.slice(3),
  }

  return (
    <Form initialValues={initialValues} onFinish={handleFinish}>
      <UserPhoto large={isBorrower} image={image} setImage={setImage} />
      {isBorrower ? (
        <>
          <Field name="firstName" label="First name" />
          <Field name="lastName" label="Last name" />
        </>
      ) : (
        <Space size={16}>
          <Field name="firstName" label="First name" />
          <Field name="lastName" label="Last name" />
        </Space>
      )}
      <Field name="email" label="Email" type="email" />
      <Field name="phone" label="Phone number" />
      <Box pt={12}>
        <Button block htmlType="submit" loading={isMutating}>
          Save
        </Button>
      </Box>
    </Form>
  )
}
